import { useAuthContext } from '@pull/pull-groupm-csp-api'


export function Logout() {
  const {logout} = useAuthContext()
    logout()
  return null
}